/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    YearlyRatiosDto,
    YearlyRatiosDtoFromJSON,
    YearlyRatiosDtoFromJSONTyped,
    YearlyRatiosDtoToJSON,
} from './YearlyRatiosDto';

/**
 * 
 * @export
 * @interface YearlyRatiosEntryDto
 */
export interface YearlyRatiosEntryDto {
    /**
     * 
     * @type {string}
     * @memberof YearlyRatiosEntryDto
     */
    year: string;
    /**
     * 
     * @type {YearlyRatiosDto}
     * @memberof YearlyRatiosEntryDto
     */
    ratios: YearlyRatiosDto;
}

export function YearlyRatiosEntryDtoFromJSON(json: any): YearlyRatiosEntryDto {
    return YearlyRatiosEntryDtoFromJSONTyped(json, false);
}

export function YearlyRatiosEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearlyRatiosEntryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': json['year'],
        'ratios': YearlyRatiosDtoFromJSON(json['ratios']),
    };
}

export function YearlyRatiosEntryDtoToJSON(value?: YearlyRatiosEntryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'ratios': YearlyRatiosDtoToJSON(value.ratios),
    };
}

